var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56134 10.7868C6.84153 11.0643 6.84153 11.5143 6.56134 11.7918C6.28115 12.0694 5.82687 12.0694 5.54667 11.7918L0.239918 6.53532C0.216521 6.51214 0.195078 6.48776 0.175589 6.46238C-0.0698426 6.1832 -0.0584252 5.7594 0.209842 5.49367L5.54665 0.207377C5.82684 -0.0701628 6.28112 -0.0701628 6.56131 0.207377C6.84151 0.484918 6.84151 0.934899 6.56131 1.21244L1.72841 5.9996L6.56134 10.7868Z",
    fill: "#D2D3D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftGray);
export default __webpack_public_path__ + "static/media/arrowLeftGray.edb5bf87eda5c91d298b1057977ec2e0.svg";
export { ForwardRef as ReactComponent };